




import { Component, Vue } from 'vue-property-decorator'
import PageIndexElastic from '~components/homepage/PageIndexElastic.vue'
import { fetchPersonalizedPosts } from '~base/utils/personalization'

@Component({
  components: {
    PageIndexElastic,
  },
  async asyncData({ app }) {
    const posts = await fetchPersonalizedPosts(app)
    return { recommendedPosts: posts }
  },
})
export default class IndexPage extends Vue {
  recommendedPosts: any[] = []
}
